import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileBenefit } from '../profile-benefit.model';
import { BenefitService } from '../benefit.service';
import { BenefitType } from '../benefit-type.model';
import { BenefitFlag } from '../benefit-flag.model';

@Component({
  selector: 'wl-benefit-flag',
  templateUrl: 'benefit-flag.component.html',
  //providers: [BenefitService, ProfileService]
    standalone: false
})
export class BenefitFlagModalComponent implements OnInit {
  public _benefitService: BenefitService;
  public benefitTypes: Array<BenefitType>;
  @Input('benefitFlag') benefitFlag: BenefitFlag;

  @Input('typeVisible') typeVisible: boolean;

  public constructor(benefitService: BenefitService) {
    this._benefitService = benefitService;
    this.benefitTypes = new Array<BenefitType>();
    this.benefitFlag = new BenefitFlag();
    this.typeVisible = false;
  }

  public onQuantityChange = (data: number) => {
    let benefitType = this.benefitTypes.filter(x => x.Id == this.benefitFlag.BenefitTypeId);
    if (benefitType.length) {
      this.benefitFlag.AmountUsed = data * benefitType[0].Value;
    }
  };

  ngOnInit() {
    this._benefitService.getBenefitTypes().then((data: Array<BenefitType>) => {
      this.benefitTypes = data;
    });
  }
}
